export default "__VITE_ASSET__DIo$SWcc__"